import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface MenuNodeBase {
  id: string;
  title: string;
  isActive: boolean;
  key?: string;
  icon?: IconDefinition;
}

export interface MenuLeafNode extends MenuNodeBase {
  kind: "leaf";
  pathname: string;
}

export interface MenuGroupNode extends MenuNodeBase {
  kind: "group";
  children: MenuNode[];
}

export type MenuNode = MenuLeafNode | MenuGroupNode;

export const isMenuGroup = (node: MenuNode): node is MenuGroupNode =>
  node.kind === "group";

const isLoginVisible = (node: MenuNode, loginIdInfo?: boolean) =>
  !(
    (node.title === "관리자 통계" ||
      node.title === "DashBoard (팀장)") &&
    !loginIdInfo
  );

export const isMenuNodeVisible = (
  node: MenuNode,
  loginIdInfo?: boolean
): boolean => {
  if (!node.isActive || !isLoginVisible(node, loginIdInfo)) {
    return false;
  }
  if (!isMenuGroup(node)) {
    return true;
  }
  return node.children.some(child => isMenuNodeVisible(child, loginIdInfo));
};

export const getVisibleChildren = (
  node: MenuGroupNode,
  loginIdInfo?: boolean
) => node.children.filter(child => isMenuNodeVisible(child, loginIdInfo));

export const hasCurrentDescendant = (
  node: MenuNode,
  pathname: string,
  loginIdInfo?: boolean
): boolean => {
  if (!isMenuNodeVisible(node, loginIdInfo)) {
    return false;
  }
  if (!isMenuGroup(node)) {
    return node.pathname === pathname;
  }
  return node.children.some(child =>
    hasCurrentDescendant(child, pathname, loginIdInfo)
  );
};

export const getCurrentAncestorIds = (
  nodes: MenuNode[],
  pathname: string,
  loginIdInfo?: boolean
): string[] => {
  for (const node of nodes) {
    if (!isMenuGroup(node) || !hasCurrentDescendant(node, pathname, loginIdInfo)) {
      continue;
    }
    return [
      node.id,
      ...getCurrentAncestorIds(node.children, pathname, loginIdInfo)
    ];
  }
  return [];
};
